import OrderSuccessDialog from "./orderSuccessDialog.container";

export default OrderSuccessDialog;

